import React from 'react'
import Navbar from '../components/common/navbar'
import Footer from '../components/common/footer'

import Hiring from '../components/hiring/hiring';


const HiringPage = () => {
    return (
        <>
            <Navbar />
            <div className='container-fluid'>
                <Hiring />
            </div>

            <Footer />
        </>
    )
}

export default HiringPage;